import { useSearchParams } from 'react-router';
import type { Periodo } from '@bi-evox/contrato';

const TZ = 'America/Sao_Paulo';
const RE = /^\d{4}-\d{2}-\d{2}$/;
const DIA = 86_400_000;

export const hojeLocal = () => new Intl.DateTimeFormat('en-CA', { timeZone: TZ }).format(new Date());
const somar = (d: string, n: number) => new Date(Date.parse(`${d}T00:00:00Z`) + n * DIA).toISOString().slice(0, 10);

export interface Atalho {
  id: string;
  rotulo: string;
  periodo: () => Periodo;
}

export const ATALHOS: Atalho[] = [
  { id: 'hoje', rotulo: 'Hoje', periodo: () => ({ de: hojeLocal(), ate: hojeLocal() }) },
  { id: 'ontem', rotulo: 'Ontem', periodo: () => ({ de: somar(hojeLocal(), -1), ate: somar(hojeLocal(), -1) }) },
  { id: '7d', rotulo: '7 dias', periodo: () => ({ de: somar(hojeLocal(), -6), ate: hojeLocal() }) },
  { id: '30d', rotulo: '30 dias', periodo: () => ({ de: somar(hojeLocal(), -29), ate: hojeLocal() }) },
  {
    id: 'mes',
    rotulo: 'Este mês',
    periodo: () => ({ de: `${hojeLocal().slice(0, 8)}01`, ate: hojeLocal() }),
  },
  {
    id: 'mes-passado',
    rotulo: 'Mês passado',
    periodo: () => {
      const fim = somar(`${hojeLocal().slice(0, 8)}01`, -1);
      return { de: `${fim.slice(0, 8)}01`, ate: fim };
    },
  },
];

const PADRAO = '7d';

/** Período na URL (?de=&ate=), para o link do painel abrir no mesmo recorte. */
export function usePeriodo(): [Periodo, (p: Periodo) => void] {
  const [params, setParams] = useSearchParams();
  const de = params.get('de');
  const ate = params.get('ate');
  const periodo =
    de && ate && RE.test(de) && RE.test(ate) && de <= ate
      ? { de, ate }
      : (ATALHOS.find((a) => a.id === PADRAO) as Atalho).periodo();
  const mudar = (p: Periodo) =>
    setParams(
      (atual) => {
        const n = new URLSearchParams(atual);
        n.set('de', p.de);
        n.set('ate', p.ate);
        return n;
      },
      { replace: true },
    );
  return [periodo, mudar];
}

export const atalhoAtivo = (p: Periodo) => ATALHOS.find((a) => {
  const x = a.periodo();
  return x.de === p.de && x.ate === p.ate;
})?.id;

export const diasEntre = (p: Periodo) => Math.round((Date.parse(p.ate) - Date.parse(p.de)) / DIA) + 1;
